import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import NotificationBar from '../../Components/NotificationBar';

function useNotificationAlert() {
  const notificationAlert = useSelector((state) => state.notification.notificationAlert);
  useEffect(() => {
    if (notificationAlert?.type) {
      toast(<NotificationBar notification={notificationAlert} />, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progressStyle: { background: '#007bff' }
      });
    }
  }, [notificationAlert]);
}

export default useNotificationAlert;
